module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuId || _vm.noMenu),
      expression: "menuId || noMenu"
    }],
    staticClass: "text-center",
    staticStyle: {
      "border": "1px solid #eee"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuId),
      expression: "menuId"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAdd),
      expression: "!isAdd"
    }],
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-0"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 text-left m-t-10"
    }, [_vm._v("\n                 \n                "), _c('label', {
      staticClass: "bg-green label label-text-60-p",
      on: {
        "click": function($event) {
          return _vm.choseAllProduct(c)
        }
      }
    }, [_vm._v("全選")]), _vm._v(" \n                "), _c('label', {
      staticClass: "bg-red label label-text-60-p",
      on: {
        "click": function($event) {
          return _vm.cancelAllProduct(c)
        }
      }
    }, [_vm._v("全取消")]), _vm._v("\n                 \n              ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 m-b-5 text-left p-x-15"
    }, [_c('div', {
      staticClass: "text-right inline-block block-checkbox text-15",
      staticStyle: {
        "margin-right": "15px",
        "margin-top": "55px"
      }
    }, [(_vm.showWord) ? _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v(_vm._s(_vm.showWord))]) : _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("加入")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [_c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.category_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, [_vm._l((c.product_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                      " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": _vm.menuClass + 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": _vm.menuClass + 'p-' + p.product_id + '-is-add'
        }
      })])])])])
    }), _vm._v(" "), _vm._l((c.package_list), function(pa, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                      " + _vm._s(pa.name) + " "), _c('small', [_vm._v(_vm._s(pa.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (pa.is_disabled),
          expression: "pa.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": _vm.menuClass + pa.package_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(pa.is_disabled) ? _vm._i(pa.is_disabled, null) > -1 : (pa.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, pa)
          },
          "change": function($event) {
            var $$a = pa.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(pa, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(pa, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(pa, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": _vm.menuClass + pa.package_id + '-is-add'
        }
      })])])])])
    })], 2)])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.isAdd) ? _c('button', {
    staticClass: "btn btn-success w-100-p text-w-600",
    on: {
      "click": function($event) {
        _vm.isAdd = !_vm.isAdd
      }
    }
  }, [_vm._v("\n        再次選擇\n      ")]) : _c('button', {
    staticClass: "btn btn-primary w-100-p text-w-600",
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("\n        確認\n      ")])])]), _vm._v(" "), (_vm.noMenu) ? _c('div', [_c('br'), _vm._v("\n    無菜單\n    "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-320c4ea4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Discount/Temp/MenuDiscountTemp.vue
// module id = 2378
// module chunks = 1